export default __webpack_public_path__ + "static/media/playerDesktopSprite.48e5c6da.png";